import { ActionStatusType } from '../enums/enums';

export class InterventionsBusinessRules {
  constructor(
    public allowedActionStatusesForInterventions: ActionStatusType[] = [],
    public assignableActionStatuses: ActionStatusType[] = [],
    public prioritizableActionStatuses: ActionStatusType[] = []
  ) {}
}
